import { render } from "./slidepickets-25.vue?vue&type=template&id=58dd4f7c&scoped=true"
import script from "./slidepickets-25.vue?vue&type=script&lang=js"
export * from "./slidepickets-25.vue?vue&type=script&lang=js"

import "./slidepickets-25.vue?vue&type=style&index=0&id=58dd4f7c&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58dd4f7c"]])

export default __exports__